(() => {
  'use strict';

  function initCatalogueV2(scope = document) {
    scope.querySelectorAll('[data-catalogue-v2]').forEach((section) => {
      if (section.dataset.catalogueV2Ready === 'true') return;
      section.dataset.catalogueV2Ready = 'true';

      const groupButtons = [...section.querySelectorAll('[data-catalogue-group]')];
      const subtabWrap = section.querySelector('[data-catalogue-subtabs]');
      const subtabs = [...section.querySelectorAll('[data-catalogue-subtab]')];
      const panels = [...section.querySelectorAll('[data-tab-panel]')];
      const sort = section.querySelector('[data-catalogue-sort]');
      const limit = Math.max(1, Number(section.dataset.productsLimit || 8));

      const activePanel = () => section.querySelector('.collection-panel.is-active:not([hidden])');

      const notifyPanelChange = () => {
        section.dispatchEvent(new CustomEvent('catalogue:panel-change', { bubbles: false }));
        const wrap = section.querySelector('[data-range-toggle-wrap]');
        const toggle = section.querySelector('[data-range-toggle]');
        const label = section.querySelector('[data-range-toggle-label]');
        const panel = activePanel();
        if (!wrap || !toggle || !label || !panel) return;
        const extras = panel.querySelectorAll('[data-range-extra]');
        wrap.hidden = extras.length === 0;
        const expanded = panel.dataset.productsExpanded === 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? (section.dataset.collapseLabel || 'RÉDUIRE') : (section.dataset.expandLabel || 'VOIR TOUS LES PRODUITS');
      };

      const setPanel = (key) => {
        panels.forEach((panel) => {
          const active = panel.dataset.tabPanel === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (active) panel.querySelectorAll('.reveal').forEach((item) => item.classList.add('is-visible'));
        });
        applySort();
        notifyPanelChange();
      };

      const setGroupButton = (group) => {
        groupButtons.forEach((button) => {
          const active = button.dataset.catalogueGroup === group;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
      };

      const activateGroup = (group) => {
        setGroupButton(group);
        if (group === 'all') {
          if (subtabWrap) subtabWrap.hidden = true;
          subtabs.forEach((button) => {
            button.hidden = true;
            button.classList.remove('is-active');
            button.setAttribute('aria-selected', 'false');
          });
          setPanel('all');
          return;
        }

        if (subtabWrap) subtabWrap.hidden = false;
        let first = null;
        subtabs.forEach((button) => {
          const match = button.dataset.catalogueSubtabGroup === group;
          button.hidden = !match;
          if (match && !first) first = button;
          if (!match) {
            button.classList.remove('is-active');
            button.setAttribute('aria-selected', 'false');
          }
        });

        if (first) {
          first.click();
          requestAnimationFrame(() => {
            applySort();
            notifyPanelChange();
          });
        } else {
          if (subtabWrap) subtabWrap.hidden = true;
          setPanel('all');
        }
      };

      const resetVisibility = (panel) => {
        const cards = [...panel.querySelectorAll('[data-product-card]')];
        const expanded = panel.dataset.productsExpanded === 'true';
        cards.forEach((card, index) => {
          const extra = index >= limit;
          if (extra) {
            card.setAttribute('data-range-extra', '');
            card.hidden = !expanded;
          } else {
            card.removeAttribute('data-range-extra');
            card.hidden = false;
          }
        });
      };

      function applySort() {
        const panel = activePanel();
        if (!panel) return;
        const grid = panel.querySelector('.product-grid');
        if (!grid) return;
        const cards = [...grid.querySelectorAll('[data-product-card]')];
        const mode = sort?.value || 'default';
        cards.sort((a, b) => {
          if (mode === 'price-asc') return Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
          if (mode === 'price-desc') return Number(b.dataset.productPrice || 0) - Number(a.dataset.productPrice || 0);
          if (mode === 'newest') return Number(b.dataset.productCreated || 0) - Number(a.dataset.productCreated || 0);
          return Number(a.dataset.productOrder || 0) - Number(b.dataset.productOrder || 0);
        });
        cards.forEach((card) => grid.appendChild(card));
        resetVisibility(panel);
      }

      groupButtons.forEach((button) => button.addEventListener('click', () => activateGroup(button.dataset.catalogueGroup)));
      subtabs.forEach((button) => button.addEventListener('click', () => requestAnimationFrame(() => {
        applySort();
        notifyPanelChange();
      })));
      sort?.addEventListener('change', () => {
        applySort();
        notifyPanelChange();
      });

      activateGroup('all');
    });
  }

  const boot = () => initCatalogueV2(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
  document.addEventListener('shopify:section:load', (event) => initCatalogueV2(event.target));
})();
